export default "https://cdn-static.gokick.com/assets/f4ff00fe02dd4df624a9917ee1bd81ca642b4b73/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";